import logoImg from "assets/logo.svg";
import Loader from "components/shared/Loader";
import classNames from "utilities/ClassNames";

interface SplashScreenInterface {
  open: boolean;
  logo?: boolean;
  flicker1?: string;
  flicker2?: string;
  status?: string;
  isScaled?: any;
}

export const SplashScreen: React.FunctionComponent<SplashScreenInterface> = ({
  open = false,
  logo = false,
  flicker1 = "LOAD",
  flicker2 = "ING",
  status,
  isScaled,
}) => {
  if (open) {
    return (
      <>
        <div className="absolute grid place-content-center h-full w-full bg-black">
          <div className="flex flex-col items-center gap-5">
            <img
              src={logoImg}
              alt="Processhub"
              className={classNames(isScaled ? "logo-large" : "logo-medium")}
            />
            <Loader />
            <div className={classNames(isScaled ? "text-2xl" : "text-base")}>
              {status}
            </div>
          </div>
        </div>
        {/* <div className="loader-container">
          <div className="loader-content">
            {logo && (
              <img src={logoImg} alt="Processhub" className="logo-medium" />
            )}
            <div className="loader">
              <span
                data-flicker-0={flicker1}
                data-flicker-1={flicker2}
                className="loader-text"
              >
                {flicker1 + flicker2}
              </span>
            </div>
            
          </div>
          <div className="loader-status">{status}</div>
        </div> */}
      </>
    );
  } else {
    return <></>;
  }
};
